export default __webpack_public_path__ + "static/media/3ba867210d4bbdac9b8d785fd6687d4d1582207987269.f92f39e3.webp";